import { Directive } from '@angular/core';

@Directive({
  selector: '[trakrSuiteAutocompleteOff]',
  host: {
    autocomplete: 'off',
    autocapitalize: 'off',
    spellcheck: 'false',
    autocorrect: 'off'
  }
})
export class TrakrSuiteAutocompleteOffDirective {

  constructor() { }

}
